import { css } from "@linaria/core";

import { boundaryPaddingProp } from "../../../styles/variables";

export const boundaryCls = css`
  --desired-width: 111rem;

  margin: 0 auto;
  padding: 0 var(${boundaryPaddingProp});

  box-sizing: border-box;
  max-width: 100%;
  width: calc(var(--desired-width) + var(${boundaryPaddingProp}) * 2);
`;
